// import request from '@/utils/request'
import config from "@/config";
import http from "@/utils/request";
export default {
	wayBill: {
		list: {
			url: `${config.API_URL}/transports/self/desc/search/page`,
			name: "业务管理",
			get: async function(params){
				this.url = `${config.API_URL}/transports/self/desc/search/page` + '?super_id=-1'
				return await http.get(this.url, params);
			}
		},
		detail: {
			url: `${config.API_URL}/transports/self/`,
			name: "业务明细",
			get: async function(params){
				this.url = `${config.API_URL}/transports/self/` + params
				return await http.get(this.url);
			}
		},
		detailChild: {
			url: `${config.API_URL}/transports/self/search/all`,
			name: "业务明细子票",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		track: {
			url: `${config.API_URL}/traces/batch/`,
			name: "轨迹跟踪",
			get: async function(data){
				this.url = `${config.API_URL}/traces/batch/` + JSON.stringify(data.nos)
				return await http.get(this.url);
			}
		},
		trackDetail: {
			url: `${config.API_URL}/traces/`,
			name: "轨迹详情",
			get: async function(data){
				this.url = `${config.API_URL}/traces/` + data
				return await http.get(this.url);
			}
		},
		batchTrack: {
			url: `${config.API_URL}/traces/self/desc/select/page?super_id=-1`,
			name: "运单查询",
			get: async function(data){
				return await http.get(this.url, data);
			}
		},
		feeTrail: {
			url: `${config.API_URL}/sell_prices/select_price/`,
			name: "运费计算",
			get: async function(data){
				this.url = `${config.API_URL}/sell_prices/select_price/` + data.params
				return await http.get(this.url, data.data);
			}
		},
		noTokenFeeTrail: {
			url: `${config.API_URL}/publish_prices/select_price/`,
			name: "运费计算2",
			get: async function(data){
				this.url = `${config.API_URL}/publish_prices/select_price/` + data.params
				return await http.get(this.url, data.data);
			}
		},
		noPayOrder: {
			url: `${config.API_URL}/transports/self/desc/search/page?super_id=-1&v_receive_status=1`,
			name: "未付款",
			get: async function(data){
				return await http.get(this.url, data);
			}
		},
		noPayOrderPrice: {
			url: `${config.API_URL}/collection_records/self/search/all`,
			name: "未付款金额",
			get: async function(data){
				return await http.get(this.url, data);
			}
		},
		pay: {
			url: `${config.API_URL}/user_pay_records/self/pay/`,
			name: "付款",
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		feeDetailList: {
			url: `${config.API_URL}/transports/self/desc/search/page?super_id=-1`,
			name: "运费明细",
			get: async function(data){
				return await http.get(this.url, data);
			}
		},
		issueList: {
			url: `${config.API_URL}/transports/self/desc/search/page?problem_status=1`,
			name: "问题件列表",
			get: async function(data){
				return await http.get(this.url, data);
			}
		},
		showProblemIssue: {
			url: `${config.API_URL}/transport_problems/transports/`,
			name: "查看问题",
			get: async function(data){
				this.url = `${config.API_URL}/transport_problems/transports/` + data
				return await http.get(this.url);
			}
		},
		problem: {
			url: `${config.API_URL}/problems`,
			name: "问题列表",
			get: async function(){
				return await http.get(this.url);
			}
		},
		billStat: {
			url: `${config.API_URL}/collection_bills/self/search/page?status=-3`,
			name: "账单统计",
			get: async function(data){
				return await http.get(this.url, data);
			}
		},
	}

}
